import { Switch, type SwitchProps } from '@monksflow/monks-ui';

/**
 * The design system ships a single switch size, so this is the design-system
 * `Switch` under the name its call sites already import. Anything that wants a
 * different track or thumb size belongs in the design system, not here.
 */
export const BigSwitch = (props: SwitchProps) => <Switch {...props} />;
